export default {"src":"/_next/static/media/fluent-location.ca270c20.svg","height":34,"width":34};